import { TableHeadCell } from "mui-datatables";
import TableCell from "@mui/material/TableCell";
export { TableHeadCell, TableCell };
export * from "./table";
export * from "./types";
export * from "./columns";
export * from "./pagination";
export * from "./pagination-counter";
export * as tableTranslations from "./i18n";
